/**
 * This is to avoid circular dependencies
 */

export const POST_STRIPE_DATA_SUCCESS = 'POST_STRIPE_DATA_SUCCESS'
